export default __webpack_public_path__ + "static/media/btn_mint.1013fd2e.png";